// Generated by CoffeeScript 1.11.1
(function() {
  var Guides;

  module.exports = Guides = (function() {
    Guides.prototype.id = 1032;

    Guides.prototype.name = 'guides';

    function Guides(resource) {
      this.resource = resource;
      this.file = this.resource.file;
      this.data = [];
    }

    Guides.prototype.parse = function() {
      var direction, i, j, location, num_guides, ref, results;
      this.file.seek(4, true);
      this.file.seek(8, true);
      num_guides = this.file.readInt();
      results = [];
      for (i = j = 1, ref = num_guides; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        location = (this.file.readInt() / 32).toFixed(1);
        direction = this.file.readByte() ? "horizontal" : "vertical";
        results.push(this.data.push({
          location: location,
          direction: direction
        }));
      }
      return results;
    };

    Guides.prototype["export"] = function() {
      return this.data;
    };

    return Guides;

  })();

}).call(this);
